import React from "react";
import NavBar from "../components/NavBar";
import HeroImage2 from "../components/HeroImage2";
import WebDesignContent from "../components/WebDesignContent";
import Footer from "../components/Footer";

const WebDesign = () => {
  return (
    <div>
      <NavBar />
      {/* <HeroImage2
        bgImage="hero-img-projects"
        heading="WEB DESIGNS"
        text="Make your business shine on the web."
      /> */}
      <div style={{ paddingTop: "100px" }}>
        <WebDesignContent />
      </div>
      
      {/* <Footer /> */}
    </div>
  );
};

export default WebDesign;
